
import { Chips, ChipsChangeEvent } from "primereact/chips";
import { useState, useEffect, CSSProperties } from "react";
import { FabrixIcon, translate } from "../../common";
import { FabrixItemProperties, initFabrixItemProperties } from "../../types";
import { ColorPicker } from "primereact/colorpicker";
import { InputTextarea } from "primereact/inputtextarea";
import OwnerSelectList from "../select-lists/owners-dropdown";
import { ValidationInput } from "../validation-input";
import { useDebounce, useIcon } from "fabrix/hooks";
import { useTranslation } from "../../hooks";
import { ValidateResult } from "@nt-portal/common-sdk";



export interface FabrixPropertiesCustomEditor {
    node?: React.ReactNode
    onChange: (data: any) => void;
}


export interface FabrixPropertiesEditorProps {
    value?: FabrixItemProperties;
    onChange?: (value: FabrixItemProperties) => void;
    className?: string;
    id?: string;
    style?: CSSProperties;
    descriptionRows?: number;
    hideOwners?: boolean;
    hideGroup?: boolean;
    hideTags?: boolean;
    hideDescription?: boolean;
    hideColor?: boolean;
    onValidate?: (item: FabrixItemProperties) => Promise<ValidateResult>;
    nameError?: string;
}

export function FabrixPropertiesEditor(props: FabrixPropertiesEditorProps) {

    const [_value, setValue] = useState<FabrixItemProperties>(props.value ?? initFabrixItemProperties());
    const translate = useTranslation();
    const icon = useIcon();
    
    const [_errorMessage, setErrorMessage] = useState<string>('');

    useEffect(() => {
        setErrorMessage(props.nameError ?? '');
    }, [props.nameError]);

    
    useEffect(() => {
        if (props.onChange)
            props.onChange(_value)
    }, [_value])

    useEffect(() => {
        setValue(props.value ?? initFabrixItemProperties())
    }, [props.value])


   


    const handleNameChange = (e: any): void => {
        let properties = { ..._value } as FabrixItemProperties;
        properties.name = e.value;
        setValue(properties);
    }


   
    const handleDescriptionChange = (e: any) => {
        let properties = { ..._value } as FabrixItemProperties;
        properties.description = e.value;
        setValue(properties);
    }


    const handleTags = (e: ChipsChangeEvent) => {
        let properties = { ..._value } as FabrixItemProperties;
        properties.tags = e.value?.map(x => x.trim());
        setValue(properties);
    }

    const handleColorChange = (e: any): void => {
        let properties = { ..._value } as FabrixItemProperties;
        properties.color = e.value;
        setValue(properties);
    }

    const handleChildPropChange = (e: any, key: string) => {
        console.log(e)
        let properties = { ..._value } as FabrixItemProperties;
        properties.children = properties.children ?? [];
        let child = properties.children.find(x => x.key === key);
        if (child) {
            child.value = e.value;
        } else {
            properties.children.push({ key: key, value: e.value });
        }

        console.log(properties)
        setValue(properties);
    }


    const style6 = { paddingLeft: 15, paddingRight: 15, border: "1px solid red", maxHeight: 100, minHeight: 80 }
    const style12 = { paddingLeft: 15, paddingRight: 15, border: "1px solid red", maxHeight: 100, minHeight: 80 }
    const style4 = { paddingLeft: 15, paddingRight: 15, border: "1px solid red", maxHeight: 100, minHeight: 80 }


    return (

        <div className={`${props.className ?? ''} grid`} style={{ height: '100%', ...props.style }} id={props.id}>


            <div className="col-6" >
                <ValidationInput errorMessage={_errorMessage} id={"name"} value={_value.name ?? ''} caption={"NAME"} keyName={"name"} required={true} onChange={handleNameChange} buttonIcon={icon(FabrixIcon.validationDropdown)} buttonIconColor="" />
            </div>
            {!props.hideTags ?
                <div className="p-fluid col-4 field" >
                    <label htmlFor="tags">{translate("TAGS")}</label>
                    <Chips value={_value.tags} className="workflow-tags" onChange={handleTags} separator="," />
                </div> : undefined}

            {!props.hideColor ?
                <div className="p-fluid col-4 field" >

                    <label className="p-mb-2" htmlFor="color-picker">{translate("SELECT_COLOR")}</label>
                    <br></br>
                    <ColorPicker style={{ width: 200 }} id="color-picker" className="fbx-color-picker" value={_value.color} onChange={handleColorChange} />

                </div> : undefined}

            {!props.hideDescription ?
                <div className="p-fluid col-12 field" >
                    <label htmlFor="tags">{translate("DESCRIPTION")}</label>
                    <InputTextarea id={`editor-description`} rows={props.descriptionRows ?? 5} className="properties-editor-item" value={_value.description} onChange={handleDescriptionChange} />
                </div> : undefined}
        </div>
    )

}


